import React, { ReactElement } from "react";
import { getCurrentYear } from "../../date";

function Footer(): ReactElement {
    return (
        <footer className="text-center w-100 fs-6 py-2 align-self-end">
            <small>
                Copyright ©
                {getCurrentYear()}
                {" "}
                Foqal. All rights reserved.
            </small>
        </footer>
    );
}

export default Footer;
